/**
 * Yükleme sınırları — web tarafı TEK KAYNAK.
 *
 * Sunucudaki `src/shared/constants/upload-limits.js` ile ELLE senkron tutulur
 * (paylaşılan paket yok). Byte sınırları burada değişirse sunucudaki multer
 * limiti de değişmeli, aksi halde istemci geçirdiği dosyada sunucudan 413 alır.
 *
 * Daha önce aynı özellik için üç farklı sınır vardı (klinik oluşturma 200 KB,
 * klinik ayarları 200 KB, klinik görünüm 400 KB) — hepsi buraya bağlandı.
 */
const KB = 1024;
const MB = 1024 * KB;

/** Klinik logosu (yatay/geniş) */
export const CLINIC_LOGO_MAX_BYTES = 5 * MB;
/** Klinik logo ikonu (küçük kare) */
export const CLINIC_LOGO_ICON_MAX_BYTES = 2 * MB;

/**
 * Piksel sınırları. Byte sınırından BAĞIMSIZ bir kuraldır: dosya küçük olsa
 * bile çözünürlük bu değerleri aşarsa yükleme reddedilir. Yerleşim/render
 * kaynaklı olduğu için byte sınırıyla birlikte otomatik yükselmez.
 */
export const CLINIC_LOGO_MAX_WIDTH = 1024;
export const CLINIC_LOGO_MAX_HEIGHT = 512;
export const CLINIC_LOGO_ICON_MAX_DIM = 128;

/** "5 MB" / "512 KB" — hata mesajlarında okunabilir sınır metni. */
export function formatMaxSize(bytes) {
  return bytes >= MB
    ? `${Math.round((bytes / MB) * 10) / 10} MB`
    : `${Math.round(bytes / KB)} KB`;
}
